module.exports = __webpack_public_path__ + "img/pers-labels-innovations.6430f260.jpg";